import { makeAutoObservable } from 'mobx'
import { PRIMARY_HOME_PATH, PRIMARY_NAV_ITEMS } from '../layout/primaryNavConfig'

class NavigationStore {
  /** Path of the highlighted primary tab (e.g. `/slop-feed`, `/profile`). */
  activePrimaryPath: string = PRIMARY_HOME_PATH

  constructor () {
    makeAutoObservable(this)
  }

  setActivePrimaryPath (path: string) {
    this.activePrimaryPath = path
  }

  /**
   * Keep tab highlight in sync with the URL (back/forward, direct links).
   */
  syncPrimaryFromLocation (pathname: string, username?: string | null) {
    for (const item of PRIMARY_NAV_ITEMS) {
      if (
        item.to === PRIMARY_HOME_PATH &&
        (pathname === PRIMARY_HOME_PATH ||
          pathname === '/' ||
          pathname.startsWith(`${PRIMARY_HOME_PATH}/`))
      ) {
        this.activePrimaryPath = item.to
        return
      }
      if (
        item.to === '/profile' &&
        (pathname === '/profile' ||
          (!!username && pathname === `/profiles/${username}`))
      ) {
        this.activePrimaryPath = item.to
        return
      }
      if (
        item.to === '/vault' &&
        (pathname === '/vault' || pathname.startsWith('/gun-vault'))
      ) {
        this.activePrimaryPath = item.to
        return
      }
      if (
        item.to === '/parts-bin' &&
        (pathname === '/parts-bin' || pathname.startsWith('/parts/'))
      ) {
        this.activePrimaryPath = item.to
        return
      }
      if (
        item.to !== PRIMARY_HOME_PATH &&
        item.to !== '/profile' &&
        item.to !== '/vault' &&
        item.to !== '/parts-bin' &&
        (pathname === item.to || pathname.startsWith(`${item.to}/`))
      ) {
        this.activePrimaryPath = item.to
        return
      }
    }
  }
}

export default NavigationStore
